import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Home/Home";
import "./darkmode.css";

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Home />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}
